import React, { useState } from 'react';
import * as Styles from './NewMacroStep2.style';
import { StepLabel } from 'components/step-label/StepLabel';
import RadioButton from 'components/radio-button/RadioButton';
import { Icon } from 'semantic-ui-react';
import FormikErrorMessage from 'components/formik-error-message/FormikErrorMessage';
import { H6 } from 'utils/resuable-css';

const NewMacroStep2 = ({ formikProp, ticketDepartment, ticketDepName, edited }) => {
  const { values, setFieldValue } = formikProp;
  const [isSubDepOpen, setIsSubDeptOpen] = useState(true);
  return (
    <Styles.NewMacroStep2SC>
      <StepLabel id="ST2" stepCount={'Step 2'}>
        {edited ? `Do you wish to change its department?` : `Please choose a department`}
      </StepLabel>
      <Styles.StepDescription>
        This macro you are creating can be associated to a specific department; if it is not related to any department,
        just do not choose one below.
      </Styles.StepDescription>
      <Styles.DepartmentSC>
        {ticketDepartment?.ticket_departments.map((val) => {
          const { ticket_department_definitions: departmentList } = ticketDepName || {};
          const department = departmentList?.find((dep) => dep.id === val.id);
          return val.sub.length === 0 ? (
            <Styles.Dept key={val.id} onClick={() => setFieldValue('department', val.id)}>
              <RadioButton
                id={val.id}
                checkbox={values.department}
                setCheckedValue={(value) => setFieldValue('department', value)}
              />
              <H6>{department?.title_en}</H6>
            </Styles.Dept>
          ) : (
            <React.Fragment key={val.id}>
              <Styles.SubDept onClick={() => setIsSubDeptOpen(!isSubDepOpen)}>
                <Icon name={isSubDepOpen ? 'angle down' : 'angle right'} size="large" />
                <H6>{val?.id}</H6>
              </Styles.SubDept>
              {isSubDepOpen &&
                val.sub.map((subDept) => {
                  const subDepartment = departmentList?.find((dep) => dep.id === subDept.id);
                  return (
                    <Styles.Dept subdept key={subDept.id} onClick={() => setFieldValue('department', subDept.id)}>
                      <RadioButton
                        id={subDept.id}
                        checkbox={values.department}
                        setCheckedValue={(value) => setFieldValue('department', value)}
                      />
                      <H6>{subDepartment?.title_en}</H6>
                    </Styles.Dept>
                  );
                })}
            </React.Fragment>
          );
        })}
        <Styles.Dept onClick={() => setFieldValue('department', '')}>
          <H6 style={{ color: '#4183c4', textDecoration: 'underline' }}> Unselect department </H6>
        </Styles.Dept>
      </Styles.DepartmentSC>
      <FormikErrorMessage formikProp={formikProp} value="department" />
    </Styles.NewMacroStep2SC>
  );
};
export default NewMacroStep2;
